import { render, staticRenderFns } from "./ViewStaffPage.vue?vue&type=template&id=850eb35c&scoped=true&"
import script from "./ViewStaffPage.vue?vue&type=script&lang=js&"
export * from "./ViewStaffPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewStaffPage.vue?vue&type=style&index=0&id=850eb35c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850eb35c",
  null
  
)

export default component.exports